import { fontStyles } from '@/components/pdf/styles';
import {
  constructNameFromTypeAndTerm,
  constructPeripheralNameFromTypeAndTerm
} from '@/pages/settings/bulk/helpers/utils';
import { PurchaseOrderBundle } from '@/services/api/contracts/catalog/bundles';
import { usePrintCurrencyString } from '@/utils/price';
import { Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';

interface PurchaseOrderDocumentPcmSectionProps {
  monthlyPcmPrice: number;
  order: PurchaseOrderBundle;
  regionCode?: string;
}

const PurchaseOrderDocumentPcmSection: FunctionComponent<PurchaseOrderDocumentPcmSectionProps> = ({
  monthlyPcmPrice,
  order,
  regionCode
}) => {
  const printCurrencyString = usePrintCurrencyString({ regionCode });
  const formattedMonthlyPcmPrice = printCurrencyString(monthlyPcmPrice);

  const models = order?.financeModels || [];
  const perModel = order?.peripheralFinanceModel;

  const selectedModelName =
    models?.length > 0
      ? constructNameFromTypeAndTerm(models[0].financeModelType, models[0].term)
      : constructPeripheralNameFromTypeAndTerm(perModel!.peripheralFinanceModelType, perModel!.term);

  const selectedModelTerm = models?.length > 0 ? models[0].term : perModel!.term;

  const totalRepayment = Number(monthlyPcmPrice.toFixed(0)) * (selectedModelTerm * 12);
  const formattedTotalPcmPrice = printCurrencyString(totalRepayment);

  return (
    <View
      style={{
        width: 250,
        border: '1px solid black',
        marginTop: 15
      }}
    >
      <Text style={{ ...fontStyles.bold, textAlign: 'center', marginBottom: 5, fontSize: 12 }}>
        Finance Illustration
      </Text>

      <View
        style={{
          flexDirection: 'row',
          fontSize: 10,
          justifyContent: 'space-between'
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 82, marginLeft: 3 }}>Monthly Payment</Text>
        <Text style={{ ...fontStyles.italic, width: 68, marginLeft: 1 }}>{selectedModelName}</Text>
        <Text style={{ ...fontStyles.italic, marginRight: 3 }}>{formattedMonthlyPcmPrice}</Text>
      </View>

      <View
        style={{
          flexDirection: 'row',
          fontSize: 10,
          justifyContent: 'space-between',
          marginTop: 2
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 150, marginLeft: 3 }}>Total Repayment</Text>
        <Text style={{ ...fontStyles.italic, marginRight: 3 }}>{formattedTotalPcmPrice}</Text>
      </View>
    </View>
  );
};

export default PurchaseOrderDocumentPcmSection;
